import {
  AGNT_CHNL,
  TURNP_CHNL,
  ACB_CHNL,
  CAT_LBS,
  PHANC_CHNL,
  SAMO_CHNL,
  CCJ_CHNL,
  TCA_CHNL,
  QLA_CHNL,
  MED_CHNL,
  MARS_CHNL,
} from '@core/roles/SalesPortalRoles.js';

export const getChannelFromProfiles = (profiles) => {
  return profiles
    .filter((profile) => !profile.includes('EREC'))
    .map((profile) => {
      if (profile.includes(AGNT_CHNL)) {
        return 'AGT';
      } else if (profile.includes(TURNP_CHNL)) {
        return 'TPB';
      } else if (profile.includes(ACB_CHNL)) {
        if (profile.includes(CAT_LBS)) return 'ACB-LBS';
        else {
          return 'ACB';
        }
      } else if (
        profile.includes(PHANC_CHNL) ||
        profile.includes(SAMO_CHNL) ||
        profile.includes(CCJ_CHNL) ||
        profile.includes(TCA_CHNL) ||
        profile.includes(QLA_CHNL) ||
        profile.includes(MED_CHNL) ||
        profile.includes(MARS_CHNL)
      ) {
        return 'PS';
      }
      return 'guest';
    })[0];
};

export const isBancaChannel = (profiles = []) => {
  const channel = getChannelFromProfiles(profiles || []);
  return channel === 'TPB' || channel === 'ACB' || channel === 'ACB-LBS';
};

export const isAcbLeaderOrLbs = (profiles = []) => {
  const acbProfiles = (profiles || []).filter((profile) =>
    profile.includes(ACB_CHNL),
  );

  if (acbProfiles.some((profile) => profile.includes(CAT_LBS))) return true;

  // Role AD đã bao hàm quyền của leader nên phải loại trừ ra khỏi nhóm leader.
  return isLeader(acbProfiles) && !isAd(acbProfiles);
};

// AFYP hiển thị cho ACB Leader/LBS là AFYP đã thu (10%), trừ 2 trường hợp loại trừ dưới đây.
export const shouldApplyPaidAfypRate = (item = {}) => {
  if (Number(item?.svhtFlg) !== 1) {
    return false;
  }
  if (Number(item?.policyTerm) === 1) {
    return true;
  }
  if (item?.isHero) {
    return true;
  }
  return false;
};

export const withHeroPackage = (productName, isHero, isBanca = true) => {
  if (isHero && isBanca) {
    return `SUN - Vững Hành Trình _ Hero package`;
  }
  return productName;
};

export const getFileLoVName = (channelCode) => {
  switch (channelCode) {
    case 'AGT':
      return 'LoV-Agency-AGT';
    case 'DLS':
      return 'LoV-BRT-AGT';
    case 'TPB':
      return 'LoV-Banca-TPB-AGT';
    case 'ACB':
      return 'LoV-Banca-ACB-AGT';
    case 'ACB-LBS':
      return 'LoV-Banca-ACB-LBS';
    case 'PS':
      return 'LoV-PRT-SHP-AGT';
    case 'FTA':
      return 'LoV-FTA-AGT';
    default:
      return 'LOV-GUEST';
  }
};

export const getLoVProfileName = (channelCode) => {
  switch (channelCode) {
    case 'AGT':
      return 'agency';
    case 'DLS':
      return 'bright';
    case 'TPB':
    case 'ACB':
    case 'ACB-LBS':
      return 'banca';
    case 'PS':
      return 'partnerShip';
    case 'FTA':
      return 'fta';
    default:
      return 'guest';
  }
};

export const getIhsDomain = (url) => {
  const { VITE_DOMAIN_NAME } = import.meta.env;
  if (VITE_DOMAIN_NAME === 'localhost') {
    return 'https://apps-vn-st.sunlifecorp.com/vnSunportal/resources';
  } else if (VITE_DOMAIN_NAME === 'https://apps-vn-st.sunlifecorp.com') {
    return 'https://apps-vn-st.sunlifecorp.com/vnSunportal/resources';
  } else if (VITE_DOMAIN_NAME === 'https://apps-vn-st2.sunlifecorp.com') {
    return 'https://apps-vn-st2.sunlifecorp.com/vnSunportal/resources';
  } else if (VITE_DOMAIN_NAME === 'https://sandbox.sunlife.com.vn') {
    return 'https://sandbox.sunlife.com.vn/vnSunportal/resources';
  } else if (VITE_DOMAIN_NAME === 'https://online.sunlife.com.vn') {
    return 'https://online.sunlife.com.vn/vnSunPortal/resources';
  }
};

export const isLeader = (profiles) => {
  let isLeader = false;
  if (profiles?.length > 0) {
    profiles.map((profile) => {
      if (
        profile.includes('CHNL-AGT') &&
        (profile.includes('MGR') ||
          profile.includes('TIER_1') ||
          profile.includes('TIER_2') ||
          profile.includes('TIER_3') ||
          profile.includes('TIER_4') ||
          profile.includes('TIER_5'))
      ) {
        isLeader = true;
      }
      return isLeader;
    });
  }
  return isLeader;
};

export const isAd = (profiles) => {
  let isAd = false;
  if (profiles?.length > 0) {
    profiles.map((profile) => {
      if (profile.includes('CHNL-AD')) {
        isAd = true;
      }
      return isAd;
    });
  }
  return isAd;
};

export const isGad = (profiles) => {
  let isGad = false;
  if (profiles?.length > 0) {
    profiles.map((profile) => {
      if (profile.includes('CHNL-GAD')) {
        isGad = true;
      }
      return isGad;
    });
  }
  return isGad;
};

export const isNonSales = (profiles) => {
  let isNonSales = false;
  if (profiles?.length > 0) {
    profiles.map((profile) => {
      if (profile.includes('NS')) {
        isNonSales = true;
      }
      return isNonSales;
    });
  }
  return isNonSales;
};

export const getChannelCodeFromProfiles = (profiles) => {
  return profiles.map((profile) => {
    return profile.split('-')[0];
  })[0];
};

export const getChannelNameFromProfiles = (profiles) => {
  const channelCode = profiles.map((profile) => {
    return profile.split('-')[0];
  })[0];

  switch (channelCode) {
    case AGNT_CHNL:
      return 'Agency';
    case TURNP_CHNL:
      return 'TPB';
    case ACB_CHNL:
      return 'ACB';
    case PHANC_CHNL:
      return 'PHAN Club';
    case SAMO_CHNL:
      return 'SAMO';
    case CCJ_CHNL:
      return 'CCJ';
    case TCA_CHNL:
      return 'TCA';
    case QLA_CHNL:
      return 'QLA';
    case MED_CHNL:
      return 'MED';
    case MARS_CHNL:
      return 'MARSconnect';
    default:
      return '';
  }
};
